export default [
  {
    path: '/active-xy2022/index',
    name: 'index',
    component: () => import('@/views/active-xy2022/index'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-xy2022/packet',
    name: 'index',
    component: () => import('@/views/active-xy2022/packet'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-xy2022/money',
    name: 'money',
    component: () => import('@/views/active-xy2022/money'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-xy2022/record',
    name: 'record',
    component: () => import('@/views/active-xy2022/record'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-xy2022/examine',
    name: 'examine',
    component: () => import('@/views/active-xy2022/examine'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-xy2022/makewish',
    name: 'makewish',
    component: () => import('@/views/active-xy2022/makewish'),
    meta: {
      title: '点亮2022心愿灯，瓜分红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  }
]
